import React from "react";
import { Routes, Route } from "react-router-dom";
import App from "../App";
import Activate from "../auth/Activate";
import Profile from "../core/Profile";
import PrivateRoute from "../auth/PrivateRoute";
import Forgot from "../auth/Forgot";
import Reset from "../auth/Reset";
import Forbidden from "../auth/Forbidden";
import Signin from "../views/Signin/Signin";
import Support from "../views/Support/Support";
import OrderPart from "../BuyerSellerStack/BuyerStack/buyer-views/OrderPart";
import UserCar from "../BuyerSellerStack/BuyerStack/buyer-views/UserCar";
import PartRequestSinglePage from "../BuyerSellerStack/BuyerStack/buyer-views/PartRequestSinglePage";
import AddUserCar from "../BuyerSellerStack/BuyerStack/buyer-views/AddUserCar";
import HomePage from "../BuyerSellerStack/BuyerStack/buyer-views/HomePage";
import Notifications from "../BuyerSellerStack/BuyerStack/buyer-views/Notifications";
import Messages from "../BuyerSellerStack/BuyerStack/buyer-views/Messages";
import PartOfferSinglePage from "../BuyerSellerStack/BuyerStack/buyer-views/PartOfferSinglePage";
import AllRequestsPage from "../BuyerSellerStack/BuyerStack/buyer-views/AllRequests";
import OnboardingHomePage from "../BuyerSellerStack/OnboardingHomePage/OnBoardingHomePage";
import RequestPage from "../BuyerSellerStack/Request/RequestPage";
import OfferPage from "../BuyerSellerStack/Request/OfferPage";
import Addresses from "../BuyerSellerStack/BuyerStack/buyer-views/Addresses";
import CreateAddressPage from "../BuyerSellerStack/BuyerStack/buyer-views/CreateAddressPage";


const AppRoutes = () => {
    return (
        <Routes>
            <Route
                path="/home"
                element={
                    <HomePage />
                }
            />

            {/* Buyer Routes */}
            <Route
                path="/order-part"
                element={
                    <OrderPart />
                }
            />

            <Route
                path="/garage/:id"
                element={
                    <UserCar />
                }
            />

            <Route
                path="/part-request/:id"
                element={
                    <PartRequestSinglePage />
                }
            />

            <Route
                path="/part-offer/:id"
                element={
                    <PartOfferSinglePage />
                }
            />

            <Route
                path="/add-user-car"
                element={
                    <AddUserCar />
                }
            />

            <Route
                path="/notifications"
                element={
                    <Notifications />
                }
            />

            <Route
                path="/messages"
                element={
                    <Messages />
                }
            />

            <Route
                path="/all-requests"
                element={
                    <AllRequestsPage />
                }
            />

            <Route
                path="/onboarding"
                element={
                    <OnboardingHomePage />
                }
            />
            <Route
                path="/request"
                element={
                    <RequestPage />
                }
            />
            <Route
                path="/offer"
                element={
                    <OfferPage />
                }
            />
            <Route
                path="/addresses"
                element={
                    <Addresses />
                }
            />
            <Route
                path="/create-address"
                element={
                    <CreateAddressPage />
                }
            />


            <Route path="/support" element={<Support />} />
            <Route path="/signin" element={<Signin />} />

            {/* Other Routes */}
            <Route path="/auth/activate/:token" element={<Activate />} />
            <Route
                path="/profile"
                element={
                    <PrivateRoute>
                        <Profile />
                    </PrivateRoute>
                }
            />
            <Route path="/auth/password/forgot" element={<Forgot />} />
            <Route path="/auth/password/reset/:token" element={<Reset />} />
            <Route path="/makes" element={<App />} />
            <Route path="/forbidden" element={<Forbidden />} />
        </Routes>
    );
};

export default AppRoutes;
